import { useCurrentUserQuery, UserDetailsFragment } from "src/generated/graphql-types";

export function useCurrentUser(): UserDetailsFragment {
  const { data } = useCurrentUserQuery({
    fetchPolicy: "cache-and-network",
  });

  return data?.currentUser ?? ({} as UserDetailsFragment);
}
